// animation js 

    const reveals = document.querySelectorAll(".reveal");

    function revealOnScroll() {

      const windowHeight = window.innerHeight;

      reveals.forEach((element) => {

        const elementTop = element.getBoundingClientRect().top;

        const revealPoint = 120;

        if (elementTop < windowHeight - revealPoint) {
          element.classList.add("active");
        }

      });
    }

    window.addEventListener("scroll", revealOnScroll);

    window.addEventListener("load", revealOnScroll);


// insta feed animation js

// window.addEventListener("load", function () {

//   setTimeout(() => {

//     const instaFeed = document.querySelector("#insta-feed");

//     if (!instaFeed) return;

//     function reveal() {

//       const top = instaFeed.getBoundingClientRect().top;

//       if (top < window.innerHeight - 100) {
//         instaFeed.classList.add("show");
//       }
//     }

//     window.addEventListener("scroll", reveal);

//     reveal();

//   }, 1000);

// });
document.addEventListener("DOMContentLoaded", function () {

    const counters = document.querySelectorAll(".stat-number");

const animateCounter = (counter) => {

    const target = parseInt(counter.dataset.count, 10);
    const originalText = counter.textContent.trim();

    const hasLeadingZero = /^0\d/.test(originalText);
    const suffix = originalText.includes("+") ? "+" : "";

    const duration = 2000;
    const startTime = performance.now();

    const updateCounter = (currentTime) => {

        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        let current = Math.floor(progress * target);

        let displayValue = current.toString();

        if (hasLeadingZero && target < 10) {
            displayValue = displayValue.padStart(2, "0");
        }

        counter.textContent = displayValue + suffix;

        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        } else {
            let finalValue = target.toString();

            if (hasLeadingZero && target < 10) {
                finalValue = finalValue.padStart(2, "0");
            }

            counter.textContent = finalValue + suffix;
        }
    };

    requestAnimationFrame(updateCounter);
};

    const observer = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                animateCounter(entry.target);

                observer.unobserve(entry.target);
            }

        });

    }, {
        threshold: 0.4
    });

    counters.forEach(counter => {
        observer.observe(counter);
    });

});

document.addEventListener("DOMContentLoaded", () => {

    const observer = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add("is-animated");
            observer.unobserve(entry.target);

        });

    }, {
        threshold: 0.15
    });

    document.querySelectorAll(".animate-on-scroll").forEach(item => {
        observer.observe(item);
    });

});